import React from 'react';
import StepCollapsed from '../../Shared/StepCollapsed/StepCollapsed';
import './EditLine.scss';
import { currency } from '../../../utils/utils';
import { getSelectedQCDFunds } from '../../../redux/modules/qcd/qcd.selectors';
import { useSelector } from 'react-redux';
const EditLine = ({
  onEditClick,
  step = 1,
  totalGrossAmount,
  step2Edit = false,
  step3Edit = false,
}) => {
  const selectedFunds = useSelector(getSelectedQCDFunds);
  return (
    <>
      {step === 2 && step2Edit && (
        <div
          className="e2e-delivery-method-chosen delivery-method-chosen"
          onClick={onEditClick}
        >
          <StepCollapsed>
            <span className="delivery-method-chosen-description blocked_data">
              {currency(totalGrossAmount)} donated to charity
            </span>
            <a
              className="e2e-edit-button college-branded-link"
              id="sell-step-1-edit"
            >
              {' '}
              Edit{' '}
            </a>
          </StepCollapsed>
        </div>
      )}
      {step === 3 && step3Edit && (
        <div
          className="e2e-delivery-method-chosen delivery-method-chosen"
          onClick={onEditClick}
        >
          <StepCollapsed>
            <span className="delivery-method-chosen-description blocked_data">
              {selectedFunds.length}{' '}
              {selectedFunds.length > 1 ? 'fund(s) selected' : 'fund selected'}
            </span>
            <a
              className="e2e-edit-button college-branded-link"
              id="sell-step-1-edit"
            >
              {' '}
              Edit{' '}
            </a>
          </StepCollapsed>
        </div>
      )}
    </>
  );
};

export default EditLine;
